import { useDispatch } from 'react-redux';

import { getReleaseGroupBaseQueryKey } from '../../../../../hooks/api/releaseGroups/useReleaseGroup';
import queryClient from '../../../../../ReactQuery/client';
import useMutation from '../../../../../ReactQuery/useMutation';
import { remove } from '../../../../../redux/api';
import ProjectGroupModule from '../../../../../redux/project_grouping';
import { useSelectedReleaseId } from '../../../../../redux/project_grouping/hooks';

const deleteRelease = (groupId: number, releaseId: number) =>
  remove(`/api/project_group/${groupId}/release/${releaseId}`);

/**
 * useDeleteRelease is a hook which provides the async callback
 * that allows us to delete a specific release group release.
 */
const useDeleteRelease = (groupId: number, releaseId: number) => {
  const dispatch = useDispatch();
  const selectedReleaseId = useSelectedReleaseId(groupId);

  return useMutation({
    mutationFn: () => deleteRelease(groupId, releaseId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: getReleaseGroupBaseQueryKey(groupId) });
      //  With no release selected, the release group page selects the latest one. This runs after the refetch
      //  above so that the deleted release is no longer the latest.
      if (selectedReleaseId === releaseId) {
        dispatch(ProjectGroupModule.actions.clearReleaseSelection());
      }
    },
  });
};

export default useDeleteRelease;
